import { EditorState } from 'prosemirror-state'

export const isEmptyDoc = (state: EditorState): boolean => {
  const doc = state.doc
  return doc.childCount === 1 && doc.firstChild?.type.name === 'paragraph' && doc.firstChild.childCount === 0
}
